import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useRef } from 'react';
import BreadCrumb from './shared/BreadCrumb';
import SlidingContent from './shared/SlidingContent';
import FAQ from './shared/Faq';
import HowTo from './shared/HowTo';
import FooterSection from './shared/FooterSection';
import Templates from './shared/Templates';
import ImageCtaSection from './shared/ImageCta';
import ReadMoreSection from './shared/ReadMore';
import HelpfulLinksSection from './shared/HelpFulLinks';
import SocialProofSection from './shared/SocialProof';
import FeaturesSection from './shared/Features';
import { Section, Grid, GridItem, Box, Typography, Button, ArrowToRight, Container, Link, Image, Hide } from '@miro-site/ui-core';
import { Primitive, styled } from '@miro-site/ui-styled-engine';
import { useWindowScroll } from '@miro-site/core';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var DottedBackGroundImage = styled(Primitive.div, {
  background: 'white',
  backgroundImage: 'radial-gradient(#d2d2d2 1px, transparent 0)',
  backgroundSize: '30px 30px',
  backgroundColor: '#F0F0F3',
  height: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
});
var HeroSection = styled(Section, {
  paddingY: '$600',
  backgroundColor: '$yellow-60',
  marginTop: '$300',
  marginBottom: '$600',
  '@lg': {
    paddingY: '$800'
  },
  '@xl': {
    paddingY: '0',
    marginTop: '$400',
    marginBottom: '$800',
    backgroundColor: 'transparent'
  }
});
var HeroImageElementsWrapper = styled(Primitive.div, _defineProperty({
  '@md': {
    height: '100%'
  }
}, "& ".concat(DottedBackGroundImage), {
  aspectRatio: '3/2',
  width: '100%',
  height: 'auto',
  borderRadius: '$200',
  position: 'relative',
  '.floating-elements': {
    display: 'none',
    '@lg': {
      display: 'block'
    }
  },
  '.main-center-image-wrapper': {
    padding: '$200',
    overflow: 'hidden',
    height: '100%',
    '@md': {
      height: 'auto'
    }
  },
  '.left-top-image-wrapper': {
    position: 'absolute',
    top: '0',
    left: '-50px',
    transform: 'translateY(0px)',
    zIndex: 1
  },
  '.left-center-image-wrapper': {
    position: 'absolute',
    left: '-6px',
    transform: 'translateY(12px)'
  },
  '.right-top-image-wrapper': {
    position: 'absolute',
    right: '0',
    top: '-20px',
    transform: 'translateY(0px)'
  },
  '.right-bottom-image-wrapper': {
    position: 'absolute',
    bottom: '-36px',
    right: '0',
    transform: 'translateY(0px)'
  }
}));
var Card = styled(Primitive.div, {
  border: '1px solid',
  borderColor: '$gray-30',
  borderRadius: '$100',
  maxWidth: '350px',
  flex: '1 0 85%',
  marginRight: '$200',
  transition: 'border 0.3s ease,box-shadow 0.3s ease',
  '@md': {
    flex: '1 0 31%'
  },
  '.image-wrapper': {
    overflow: 'hidden'
  },
  '.content-wrapper': {
    padding: '$200',
    '@md': {
      padding: '$300'
    }
  },
  img: {
    transform: 'scale(1) rotate(0deg)',
    aspectRatio: '3/2',
    transition: 'all 0.3s ease-in-out'
  },
  '&:hover': {
    cursor: 'pointer',
    boxShadow: '$50',
    borderColor: '$gray-30',
    img: {
      transform: 'scale(1.2) rotate(10deg)'
    }
  }
});
var KpiContentGridItem = styled(GridItem, {
  display: 'flex',
  flexDirection: 'column',
  '.kpi-container': {
    width: '100%',
    '&:not(:last-child)': {
      borderBottom: '1px solid $indigo-20',
      marginBottom: '$400'
    },
    '@sm': {
      paddingRight: '$300',
      '&:not(:last-child)': {
        borderBottomWidth: '0',
        marginBottom: '0'
      }
    },
    '@md': {
      paddingRight: '$400'
    },
    '@xl': {
      '&:not(:last-child)': {
        borderBottom: '1px solid $indigo-20',
        marginBottom: '$400'
      },
      paddingRight: '0'
    }
  },
  '@sm': {
    flexDirection: 'row',
    '.kpi-container': {
      width: '50%'
    }
  },
  '@xl': {
    paddingX: '$600',
    flexDirection: 'column',
    '.kpi-container': {
      width: '100%'
    }
  }
});
var KpiImageContainer = styled(Primitive.div, {
  overflow: 'hidden',
  '@md': {
    marginBottom: '$600'
  },
  '@lg': {
    marginBottom: '$800'
  },
  '@xl': {
    marginBottom: '0'
  }
});
/**
 * Questions
 * Storybook is failing
 * @returns
 */

var SeoUseCase = function SeoUseCase(props) {
  var _props$heroSection, _props$heroSection2, _props$heroSection3, _props$heroSection3$c, _props$heroSection4, _props$heroSection4$c, _heroSection$mainCent, _heroSection$mainCent2, _heroSection$leftTopI, _heroSection$leftTopI2, _heroSection$leftCent, _heroSection$leftCent2, _heroSection$rightTop, _heroSection$rightTop2, _heroSection$rightBot, _heroSection$rightBot2, _kpiSection$image, _kpiSection$image2, _kpiSection$metrics;

  var _ref = props || {},
      socialProof = _ref.socialProof,
      heroSection = _ref.heroSection,
      howToSection = _ref.howToSection,
      templateSection = _ref.templateSection,
      imageCtaSection = _ref.imageCtaSection,
      faqSection = _ref.faqSection,
      readMoreSection = _ref.readMoreSection,
      contentSection = _ref.contentSection,
      sliderSection = _ref.sliderSection,
      cardsSection = _ref.cardsSection,
      featureSection = _ref.featureSection,
      kpiSection = _ref.kpiSection,
      helpfulLinksSection = _ref.helpfulLinksSection,
      footerSection = _ref.footerSection;

  var heroImageContainer = useRef();

  var onWindowScroll = function onWindowScroll() {
    var top = window.scrollY;

    if (top <= 500) {
      var _heroImageContainer$c, _heroImageContainer$c2, _heroImageContainer$c3, _heroImageContainer$c4;

      var topLeftImage = heroImageContainer === null || heroImageContainer === void 0 ? void 0 : (_heroImageContainer$c = heroImageContainer.current) === null || _heroImageContainer$c === void 0 ? void 0 : _heroImageContainer$c.querySelector('.left-top-image-wrapper');
      var topRightImage = heroImageContainer === null || heroImageContainer === void 0 ? void 0 : (_heroImageContainer$c2 = heroImageContainer.current) === null || _heroImageContainer$c2 === void 0 ? void 0 : _heroImageContainer$c2.querySelector('.right-top-image-wrapper');
      var leftCenterImage = heroImageContainer === null || heroImageContainer === void 0 ? void 0 : (_heroImageContainer$c3 = heroImageContainer.current) === null || _heroImageContainer$c3 === void 0 ? void 0 : _heroImageContainer$c3.querySelector('.left-center-image-wrapper');
      var rightBottomImage = heroImageContainer === null || heroImageContainer === void 0 ? void 0 : (_heroImageContainer$c4 = heroImageContainer.current) === null || _heroImageContainer$c4 === void 0 ? void 0 : _heroImageContainer$c4.querySelector('.right-bottom-image-wrapper');
      topLeftImage.style.transform = "translateY(-".concat(top / 9, "px)");
      topRightImage.style.transform = "translateY(-".concat(top / 3, "px)");
      leftCenterImage.style.transform = "translateY(-".concat(top / 4, "px)");
      rightBottomImage.style.transform = "translateY(-".concat(top / 9, "px)");
    }
  };

  useWindowScroll(onWindowScroll);

  var slidingContentGenerator = function slidingContentGenerator(index) {
    var _currentItem$sliderIm, _currentItem$cta, _currentItem$cta2;

    var currentItem = sliderSection[index];

    if (!currentItem) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }

    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Hide, {
        upTo: "md",
        children: /*#__PURE__*/_jsx(Typography, {
          variant: "body-text-2",
          offsetBottom: "stacking-200",
          renderChildrenAsHTML: true,
          children: currentItem.titleSmall || ''
        })
      }), /*#__PURE__*/_jsx(Hide, {
        from: "md",
        children: (currentItem === null || currentItem === void 0 ? void 0 : (_currentItem$sliderIm = currentItem.sliderImage) === null || _currentItem$sliderIm === void 0 ? void 0 : _currentItem$sliderIm.desktop) && /*#__PURE__*/_jsx(Image, {
          image: currentItem.sliderImage.desktop
        })
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "heading-2",
        offsetBottom: {
          '@initial': 'stacking-200',
          '@md': 'stacking-300'
        },
        offsetTop: {
          '@initial': '400',
          '@md': 'none'
        },
        renderChildrenAsHTML: true,
        children: currentItem.title || ''
      }), /*#__PURE__*/_jsx(Typography, {
        variant: "body-text-1",
        offsetBottom: "400",
        renderChildrenAsHTML: true,
        children: currentItem.content || ''
      }), /*#__PURE__*/_jsx(Button, {
        appearance: "outlined",
        endIcon: /*#__PURE__*/_jsx(ArrowToRight, {}),
        rounded: true,
        size: "large",
        variant: "primary",
        href: currentItem === null || currentItem === void 0 ? void 0 : (_currentItem$cta = currentItem.cta) === null || _currentItem$cta === void 0 ? void 0 : _currentItem$cta.href,
        children: currentItem === null || currentItem === void 0 ? void 0 : (_currentItem$cta2 = currentItem.cta) === null || _currentItem$cta2 === void 0 ? void 0 : _currentItem$cta2.text
      })]
    });
  };

  var slidingImageGenerator = function slidingImageGenerator(index) {
    var _currentItem$sliderIm2;

    var currentItem = sliderSection[index];

    if (!currentItem) {
      return /*#__PURE__*/_jsx(_Fragment, {});
    }

    return /*#__PURE__*/_jsx(DottedBackGroundImage, {
      css: {
        display: 'none',
        '@md': {
          display: 'flex'
        }
      },
      children: (currentItem === null || currentItem === void 0 ? void 0 : (_currentItem$sliderIm2 = currentItem.sliderImage) === null || _currentItem$sliderIm2 === void 0 ? void 0 : _currentItem$sliderIm2.desktop) && /*#__PURE__*/_jsx(Image, {
        image: currentItem.sliderImage.desktop
      })
    });
  };

  var onCardClick = function onCardClick(card) {
    return function () {
      var _card$cta;

      if (card !== null && card !== void 0 && (_card$cta = card.cta) !== null && _card$cta !== void 0 && _card$cta.href) window.location.href = card.cta.href;
    };
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Section, {
      backgroundColor: "$yellow-20",
      css: {
        padding: 0
      },
      children: /*#__PURE__*/_jsx(Container, {
        disableGutter: true,
        children: /*#__PURE__*/_jsx(BreadCrumb, {
          homeKeyWord: heroSection === null || heroSection === void 0 ? void 0 : heroSection.homeKeyword
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      backgroundColor: "$yellow-20",
      css: {
        position: 'absolute',
        width: '100%',
        height: '150px',
        zIndex: '-1'
      },
      children: ''
    }), /*#__PURE__*/_jsx(HeroSection, {
      children: /*#__PURE__*/_jsx(Box, {
        css: {
          backgroundColor: '$yellow-60',
          borderRadius: '$200',
          '@lg': {
            paddingX: '$400',
            marginX: '-$400'
          },
          '@xl': {
            paddingY: '$800'
          }
        },
        children: /*#__PURE__*/_jsxs(Grid, {
          css: {
            gridRowGap: '0'
          },
          children: [/*#__PURE__*/_jsx(GridItem, {
            columnStart: "1",
            columnEnd: {
              '@initial': -1,
              '@md': 7
            },
            children: /*#__PURE__*/_jsxs(Box, {
              css: {
                textAlign: 'center',
                '@md': {
                  textAlign: 'left'
                },
                '@lg': {
                  paddingRight: '$400'
                },
                '@xl': {
                  paddingRight: '$600'
                }
              },
              children: [/*#__PURE__*/_jsx(Typography, {
                variant: "heading-1",
                type: "heading",
                tag: "h1",
                offsetBottom: "stacking-300",
                renderChildrenAsHTML: true,
                children: (props === null || props === void 0 ? void 0 : (_props$heroSection = props.heroSection) === null || _props$heroSection === void 0 ? void 0 : _props$heroSection.title) || ''
              }), /*#__PURE__*/_jsx(Typography, {
                variant: "body-text-1",
                offsetBottom: "stacking-400",
                renderChildrenAsHTML: true,
                children: (props === null || props === void 0 ? void 0 : (_props$heroSection2 = props.heroSection) === null || _props$heroSection2 === void 0 ? void 0 : _props$heroSection2.subTitle) || ''
              }), /*#__PURE__*/_jsx(Button, {
                appearance: "filled",
                endIcon: /*#__PURE__*/_jsx(ArrowToRight, {}),
                rounded: true,
                size: "large",
                variant: "primary",
                href: props === null || props === void 0 ? void 0 : (_props$heroSection3 = props.heroSection) === null || _props$heroSection3 === void 0 ? void 0 : (_props$heroSection3$c = _props$heroSection3.cta) === null || _props$heroSection3$c === void 0 ? void 0 : _props$heroSection3$c.href,
                css: {
                  marginBottom: '$400',
                  '@md': {
                    marginBottom: 0
                  }
                },
                children: props === null || props === void 0 ? void 0 : (_props$heroSection4 = props.heroSection) === null || _props$heroSection4 === void 0 ? void 0 : (_props$heroSection4$c = _props$heroSection4.cta) === null || _props$heroSection4$c === void 0 ? void 0 : _props$heroSection4$c.text
              })]
            })
          }), /*#__PURE__*/_jsx(GridItem, {
            columnStart: {
              '@initial': 1,
              '@md': 7
            },
            columnEnd: "-1",
            children: /*#__PURE__*/_jsx(HeroImageElementsWrapper, {
              children: /*#__PURE__*/_jsxs(DottedBackGroundImage, {
                ref: heroImageContainer,
                children: [/*#__PURE__*/_jsx("div", {
                  className: "main-center-image-wrapper",
                  children: (heroSection === null || heroSection === void 0 ? void 0 : (_heroSection$mainCent = heroSection.mainCenterImage) === null || _heroSection$mainCent === void 0 ? void 0 : (_heroSection$mainCent2 = _heroSection$mainCent.desktop) === null || _heroSection$mainCent2 === void 0 ? void 0 : _heroSection$mainCent2.src) && /*#__PURE__*/_jsx(Image, {
                    image: heroSection.mainCenterImage.desktop
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "left-top-image-wrapper floating-elements",
                  children: (heroSection === null || heroSection === void 0 ? void 0 : (_heroSection$leftTopI = heroSection.leftTopImage) === null || _heroSection$leftTopI === void 0 ? void 0 : (_heroSection$leftTopI2 = _heroSection$leftTopI.desktop) === null || _heroSection$leftTopI2 === void 0 ? void 0 : _heroSection$leftTopI2.src) && /*#__PURE__*/_jsx(Image, {
                    image: heroSection.leftTopImage.desktop
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "left-center-image-wrapper floating-elements",
                  children: (heroSection === null || heroSection === void 0 ? void 0 : (_heroSection$leftCent = heroSection.leftCenterImage) === null || _heroSection$leftCent === void 0 ? void 0 : (_heroSection$leftCent2 = _heroSection$leftCent.desktop) === null || _heroSection$leftCent2 === void 0 ? void 0 : _heroSection$leftCent2.src) && /*#__PURE__*/_jsx(Image, {
                    image: heroSection.leftCenterImage.desktop
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "right-top-image-wrapper floating-elements",
                  children: (heroSection === null || heroSection === void 0 ? void 0 : (_heroSection$rightTop = heroSection.rightTopImage) === null || _heroSection$rightTop === void 0 ? void 0 : (_heroSection$rightTop2 = _heroSection$rightTop.desktop) === null || _heroSection$rightTop2 === void 0 ? void 0 : _heroSection$rightTop2.src) && /*#__PURE__*/_jsx(Image, {
                    image: heroSection.rightTopImage.desktop
                  })
                }), /*#__PURE__*/_jsx("div", {
                  className: "right-bottom-image-wrapper floating-elements",
                  children: (heroSection === null || heroSection === void 0 ? void 0 : (_heroSection$rightBot = heroSection.rightBottomImage) === null || _heroSection$rightBot === void 0 ? void 0 : (_heroSection$rightBot2 = _heroSection$rightBot.desktop) === null || _heroSection$rightBot2 === void 0 ? void 0 : _heroSection$rightBot2.src) && /*#__PURE__*/_jsx(Image, {
                    image: heroSection.rightBottomImage.desktop
                  })
                })]
              })
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(SocialProofSection, _objectSpread({}, socialProof)), /*#__PURE__*/_jsx(Section, {
      pageTopInset: "1200",
      children: /*#__PURE__*/_jsx(Box, {
        children: /*#__PURE__*/_jsxs(Grid, {
          css: {
            gridRowGap: '0'
          },
          children: [/*#__PURE__*/_jsx(GridItem, {
            columnStart: "1",
            columnEnd: {
              '@initial': -1,
              '@sm': 7,
              '@md': 6
            },
            children: /*#__PURE__*/_jsx(Typography, {
              tag: "h2",
              type: "heading",
              variant: "heading-2",
              offsetBottom: {
                '@initial': 'stacking-200',
                '@md': 'none'
              },
              renderChildrenAsHTML: true,
              children: (contentSection === null || contentSection === void 0 ? void 0 : contentSection.title) || ''
            })
          }), /*#__PURE__*/_jsx(GridItem, {
            columnStart: {
              '@initial': 1,
              '@md': 7
            },
            columnEnd: "-1",
            children: /*#__PURE__*/_jsx(Typography, {
              css: {
                '@md': {
                  paddingTop: '5px'
                }
              },
              variant: "body-text-1",
              renderChildrenAsHTML: true,
              children: (contentSection === null || contentSection === void 0 ? void 0 : contentSection.content) || ''
            })
          })]
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      children: /*#__PURE__*/_jsx(Grid, {
        children: /*#__PURE__*/_jsx(GridItem, {
          xs: 12,
          children: /*#__PURE__*/_jsx(Box, {
            offsetTop: {
              '@initial': '600',
              '@md': '800',
              '@xl': '1200'
            },
            css: {
              display: 'flex',
              overflow: 'auto'
            },
            children: cardsSection === null || cardsSection === void 0 ? void 0 : cardsSection.map(function (card, index) {
              var _card$image, _card$image$desktop, _card$cta2, _card$cta3;

              return /*#__PURE__*/_jsxs(Card, {
                onClick: onCardClick(card),
                children: [/*#__PURE__*/_jsx("div", {
                  className: "image-wrapper",
                  children: (card === null || card === void 0 ? void 0 : (_card$image = card.image) === null || _card$image === void 0 ? void 0 : (_card$image$desktop = _card$image.desktop) === null || _card$image$desktop === void 0 ? void 0 : _card$image$desktop.src) && /*#__PURE__*/_jsx(Image, {
                    image: card.image.desktop
                  })
                }), /*#__PURE__*/_jsxs("div", {
                  className: "content-wrapper",
                  children: [/*#__PURE__*/_jsx(Typography, {
                    variant: "sub-heading-1",
                    offsetBottom: "stacking-200",
                    renderChildrenAsHTML: true,
                    children: card.title || ''
                  }), /*#__PURE__*/_jsx(Typography, {
                    variant: "body-text-1",
                    offsetBottom: "600",
                    renderChildrenAsHTML: true,
                    children: card.content || ''
                  }), /*#__PURE__*/_jsx(Link, {
                    href: card === null || card === void 0 ? void 0 : (_card$cta2 = card.cta) === null || _card$cta2 === void 0 ? void 0 : _card$cta2.href,
                    className: "card-link",
                    children: card === null || card === void 0 ? void 0 : (_card$cta3 = card.cta) === null || _card$cta3 === void 0 ? void 0 : _card$cta3.text
                  })]
                })]
              }, 'cards-' + index);
            })
          })
        })
      })
    }), /*#__PURE__*/_jsx(Section, {
      backgroundColor: "$blue-20",
      css: {
        marginTop: '$800',
        paddingY: '$600',
        '@lg': {
          paddingY: '$800'
        },
        '@md': {
          marginTop: '$1200'
        },
        '@xl': {
          marginTop: '$1600'
        }
      },
      children: /*#__PURE__*/_jsxs(Grid, {
        css: {
          gridRowGap: '0'
        },
        children: [/*#__PURE__*/_jsxs(GridItem, {
          xs: 12,
          sm: 9,
          md: 6,
          xl: 5,
          rowStart: {
            '@initial': 1
          },
          css: {
            paddingRight: '0',
            '@md': {
              paddingRight: '$400'
            },
            '@xl': {
              paddingRight: '0'
            }
          },
          children: [/*#__PURE__*/_jsx(Typography, {
            variant: "heading-2",
            type: "heading",
            tag: "h3",
            offsetBottom: {
              '@initial': '300',
              '@xl': 'stacking-800'
            },
            renderChildrenAsHTML: true,
            children: (kpiSection === null || kpiSection === void 0 ? void 0 : kpiSection.title) || ''
          }), /*#__PURE__*/_jsx(Hide, {
            from: "xl",
            children: /*#__PURE__*/_jsx(Typography, {
              variant: "body-text-1",
              offsetBottom: {
                '@initial': 'stacking-800',
                '@md': '600'
              },
              renderChildrenAsHTML: true,
              children: (kpiSection === null || kpiSection === void 0 ? void 0 : kpiSection.content) || ''
            })
          })]
        }), /*#__PURE__*/_jsx(GridItem, {
          xs: 12,
          md: 6,
          rowStart: {
            '@initial': 3,
            '@md': 1,
            '@xl': 2
          },
          css: {
            overflow: 'hidden'
          },
          children: /*#__PURE__*/_jsx(KpiImageContainer, {
            children: (kpiSection === null || kpiSection === void 0 ? void 0 : (_kpiSection$image = kpiSection.image) === null || _kpiSection$image === void 0 ? void 0 : _kpiSection$image.desktop) && /*#__PURE__*/_jsx(Image, {
              image: kpiSection === null || kpiSection === void 0 ? void 0 : (_kpiSection$image2 = kpiSection.image) === null || _kpiSection$image2 === void 0 ? void 0 : _kpiSection$image2.desktop
            })
          })
        }), /*#__PURE__*/_jsx(KpiContentGridItem, {
          xs: "12",
          rowStart: {
            '@xl': 2
          },
          children: /*#__PURE__*/_jsxs(_Fragment, {
            children: [/*#__PURE__*/_jsx(Hide, {
              upTo: "xl",
              children: /*#__PURE__*/_jsx(Typography, {
                variant: "body-text-1",
                offsetBottom: "stacking-800",
                renderChildrenAsHTML: true,
                children: (kpiSection === null || kpiSection === void 0 ? void 0 : kpiSection.content) || ''
              })
            }), kpiSection === null || kpiSection === void 0 ? void 0 : (_kpiSection$metrics = kpiSection.metrics) === null || _kpiSection$metrics === void 0 ? void 0 : _kpiSection$metrics.map(function (metric, index) {
              return /*#__PURE__*/_jsxs("div", {
                className: "kpi-container",
                children: [/*#__PURE__*/_jsx(Typography, {
                  variant: "heading-3",
                  tag: "h4",
                  type: "heading",
                  offsetBottom: "stacking-200",
                  renderChildrenAsHTML: true,
                  children: metric.title || ''
                }), /*#__PURE__*/_jsx(Typography, {
                  variant: "body-text-1",
                  offsetBottom: {
                    '@initial': 'stacking-400',
                    '@md': 'none',
                    '@xl': '400'
                  },
                  renderChildrenAsHTML: true,
                  children: metric.content || ''
                })]
              }, 'kpi-' + index);
            })]
          })
        })]
      })
    }), (sliderSection === null || sliderSection === void 0 ? void 0 : sliderSection.length) && /*#__PURE__*/_jsx(Section, {
      pageTopInset: "1200",
      children: /*#__PURE__*/_jsx(SlidingContent, {
        slidingContentGenerator: slidingContentGenerator,
        slidingImageGenerator: slidingImageGenerator,
        itemCount: sliderSection.length,
        contentColumnStartIndex: 1,
        contentColumnEndIndex: 7,
        imageColumnStartIndex: 7,
        imageColumnEndIndex: -1,
        imageGridItemCss: {
          background: 'white',
          height: 'auto',
          '@md': {
            padding: '30% 0',
            background: 'transparent'
          }
        }
      })
    }), /*#__PURE__*/_jsx(FeaturesSection, _objectSpread({}, featureSection)), /*#__PURE__*/_jsx(HowTo, _objectSpread({}, howToSection)), /*#__PURE__*/_jsx(Templates, _objectSpread({}, templateSection)), /*#__PURE__*/_jsx(ImageCtaSection, {
      props: imageCtaSection
    }), /*#__PURE__*/_jsx(FAQ, _objectSpread({}, faqSection)), /*#__PURE__*/_jsx(ReadMoreSection, _objectSpread({}, readMoreSection)), /*#__PURE__*/_jsx(HelpfulLinksSection, _objectSpread({}, helpfulLinksSection)), /*#__PURE__*/_jsx(FooterSection, _objectSpread({}, footerSection))]
  });
};

export default SeoUseCase;